export default __webpack_public_path__ + "static/media/homeHeaderPolygonLeft.042507a9.svg";